import Navbar from './components/Navbar';
import Hero from './components/Hero';
import CategoryGrid from './components/CategoryGrid';
import ProductShowcase from './components/ProductShowcase';
import ArticleSection from './components/ArticleSection';
import CTASection from './components/CTASection';
import TrustSection from './components/TrustSection';
import Footer from './components/Footer';
import JsonLd from '@/components/base/JsonLd';

const siteUrl = import.meta.env.VITE_SITE_URL || 'https://cssspreadsheet.cyou';

const websiteSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: 'CSSBuy Spreadsheet',
  url: siteUrl,
  description: 'Find the best CSSBuy spreadsheets, shopping lists, and agent comparison guides for 2026. Discover curated product lists across shoes, clothing, bags, accessories and more.',
  inLanguage: 'en',
  publisher: {
    '@type': 'Organization',
    name: 'CSSSpreadsheet',
    url: siteUrl,
  },
};

export default function Home() {
  return (
    <>
      <JsonLd schema={websiteSchema} />
      <Navbar />
      <main>
        <Hero />
        <CategoryGrid />
        <ProductShowcase />
        <ArticleSection />
        <CTASection />
        <TrustSection />
      </main>
      <Footer />
    </>
  );
}